import './PersonView.css'
import {useLocation, useParams} from "react-router-dom";
import React, {ReactNode, useContext, useEffect, useState} from "react";
import HeadNavigation from "../../Components/HeadNavigation/HeadNavigation";
import {formatAndCalculateAge, Person} from "../BirthdayView/BirthdayView";
import {Context} from "../../ContextProvider/Context";
import Switch from "react-switch";
import {Api, BackendAnswerType} from "../../RequestsProvider/RequestProvider";
import {toast} from "react-toastify";

export const PersonView = () => {
    const location = useLocation()
    const {id} = useParams()
    const [name, setName] = useState(new URLSearchParams(location.search).get("name"))
    const [showModal, setShowModal] = useState(false)
    const [person, setPerson] = useState<Person>()

    const context = useContext(Context)
    const request = useContext(Api)

    const {setContentLoading} = context!
    const {
        getPersonByID,
        updateCongratulateOnBirthday,
        updateTranscribeHidden,
        updateTranslateTranscriptions
    } = request!

    const getPerson = async () => {
        const response = await getPersonByID(id ?? '')
        if (response.type !== BackendAnswerType.unknownError) {
            setPerson(response.message[0])
            setTimeout(() => setContentLoading(false), 600)
        } else {
            toast('Person nicht gefunden.')
        }
    }

    useEffect(() => {
        setContentLoading(true)
        getPerson().then()
    }, []);

    const handleChange_transcribeHidden = async (newValue: boolean) => {
        if (!person) {
            return
        }
        const response = await updateTranscribeHidden(person.id, newValue)
        if (response.type === 'updatedPerson') {
            setPerson(person => ({
                ...person!,
                transcribeHidden: response.message
            }));
        } else {
            toast('Etwas ist schief gelaufen 😔')
        }
        setTimeout(() => setContentLoading(false), 600)
    }
    const handleChange_translateTranscriptions = async (newValue: boolean) => {
        if (!person) {
            return
        }
        const response = await updateTranslateTranscriptions(person.id, newValue)
        if (response.type === 'updatedPerson') {
            setPerson(person => ({
                ...person!,
                translateTranscriptions: response.message
            }));
        } else {
            toast('Etwas ist schief gelaufen 😔')
        }
        setTimeout(() => setContentLoading(false), 600)
    }
    const mapChatOrGroup = (val: string) => {
        switch (val) {
            case 'chat':
                return "Chat"
            case 'group':
                return "Gruppe"
        }
    }
    const handleChange_congratulateOnBirthday = async (newValue: boolean) => {
        if (!person) {
            return
        }
        const response = await updateCongratulateOnBirthday(person.id, newValue)
        if (response.type === 'updatedPerson') {
            setPerson(person => ({
                ...person!,
                congratulateOnBirthday: response.message
            }));
        } else {
            toast('Etwas ist schief gelaufen 😔')
        }
        setTimeout(() => setContentLoading(false), 600)

    }
    const formatTel = (tel: string | undefined) => {
        let mod_tel = tel?.replace(/^49/, "0")
        mod_tel = mod_tel?.replace(/@c\.us$/, "")
        const formatted = mod_tel?.slice(0, 4) + " " + mod_tel?.slice(4)
        return formatted !== "undefined undefined" ? formatted : ""
    }

    return (<>
        <HeadNavigation path={[{path: "/", pathName: "Startseite"}, {path: "/personen", pathName: "Personen"}, {
            path: null,
            pathName: name
        }]}/>
        <div className="grid">
            <div className="grid-item2-container">
                <div className="grid-item1">
                    <div className="grid-item2-container employee-card border">
                        <div className="employee-card-header-logo">
                            {person?.profilePictureURL ?
                                <img className="img-fluid rounded-circle" src={person?.profilePictureURL} alt=""
                                     width={100} height={100}/> :
                                <svg className="fsvg-global-var-fill" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                     width={60} height={60} fill={'#000000'}
                                     viewBox="0 0 50 50">
                                    <path
                                        d="M 21.261719 -0.013671875 A 1.0001 1.0001 0 0 0 20.257812 0.875 L 20.078125 2.3164062 C 19.300118 2.7280205 18.770723 3.3487022 18.439453 4.0292969 C 13.741897 4.3216488 10 8.2307367 10 13 L 10 45 A 1.0001 1.0001 0 0 0 10.199219 45.599609 C 10.199219 45.599609 11.153663 46.819996 13.302734 47.894531 C 15.451806 48.969067 18.866667 50 24 50 C 28.555556 50 31.619883 49.620555 33.570312 49.230469 C 35.520742 48.840383 36.447266 48.394531 36.447266 48.394531 A 1.0001 1.0001 0 0 0 37 47.5 L 37 43.5 A 1.0001 1.0001 0 0 0 36 42.5 L 36 36.015625 C 36.832001 35.81523 37.509606 35.610422 37.900391 35.439453 C 38.350152 35.242683 38.658203 35.001953 38.658203 35.001953 A 1.0001 1.0001 0 0 0 39 34.25 L 39 32 C 41.749516 32 44 29.749516 44 27 L 44 25 L 44 23.158203 C 44 20.243768 42.188347 17.626735 39.458984 16.603516 L 39.550781 16.644531 L 37 15.378906 L 37 13 C 37 8.2307367 33.258103 4.3216488 28.560547 4.0292969 C 28.229277 3.3487022 27.699882 2.7280204 26.921875 2.3164062 L 26.742188 0.875 A 1.0001 1.0001 0 0 0 25.708984 -0.013671875 A 1.0001 1.0001 0 0 0 24.757812 1.125 L 24.867188 2 L 22.132812 2 L 22.242188 1.125 A 1.0001 1.0001 0 0 0 21.261719 -0.013671875 z M 21.248047 4 L 25.751953 4 C 26.589514 4.3144261 26.853569 4.8916798 26.923828 5.5292969 C 26.795831 5.5841359 26.685495 5.6409786 26.445312 5.7011719 C 25.749592 5.8755301 24.6828 6 23.5 6 C 22.3172 6 21.250407 5.8755301 20.554688 5.7011719 C 20.314506 5.6409786 20.204169 5.584136 20.076172 5.5292969 C 20.146431 4.8916798 20.410486 4.3144261 21.248047 4 z M 18.035156 6.0742188 C 18.120498 6.6352697 18.516501 6.9786494 18.841797 7.171875 C 19.206159 7.3883059 19.605673 7.5241791 20.070312 7.640625 C 20.999592 7.8735168 22.1828 8 23.5 8 C 24.8172 8 26.000407 7.8735168 26.929688 7.640625 C 27.394327 7.5241791 27.793841 7.3883059 28.158203 7.171875 C 28.483499 6.9786494 28.879502 6.6352697 28.964844 6.0742188 C 32.381051 6.5430434 35 9.4511148 35 13 L 35 15.314453 C 34.244641 15.57807 32.661791 16 30 16 C 27.055556 16 25.398204 15.759901 24.054688 15.515625 C 22.711171 15.271349 21.611111 15 20 15 C 16.698375 15 14 17.698375 14 21 L 14 26 C 14 29.301625 16.698375 32 20 32 L 37 32 L 37 33.636719 C 36.688566 33.767995 36.184032 33.952236 35.287109 34.148438 C 33.389078 34.563631 29.951389 35 24 35 C 22.355997 35 20.916942 34.888595 19.662109 34.705078 C 19.570279 34.691708 19.489609 34.734662 19.398438 34.726562 A 1.0001 1.0001 0 0 0 18.462891 34.800781 C 16.008223 35.06851 14 37.077475 14 39.660156 L 14 39.707031 C 14 42.390954 15.823594 44.659797 18.351562 45.392578 A 1.0001 1.0001 0 0 0 19.033203 45.630859 C 19.034703 45.631094 19.035609 45.632512 19.037109 45.632812 C 20.474214 45.861542 22.119847 46 24 46 C 24.279511 46 24.438655 45.973473 24.707031 45.970703 A 1.0001 1.0001 0 0 0 25.367188 45.943359 C 27.553048 45.899289 29.356473 45.788796 30.814453 45.615234 A 1.0001 1.0001 0 0 0 30.816406 45.615234 A 1.0001 1.0001 0 0 0 31.441406 45.527344 C 32.16887 45.428044 33.025196 45.339492 33.570312 45.230469 C 34.439074 45.056716 34.380668 45.009021 34.851562 44.857422 A 1.0001 1.0001 0 0 0 35 44.871094 L 35 46.759766 C 34.767715 46.858046 34.560173 46.993434 33.179688 47.269531 C 31.380116 47.629445 28.444444 48 24 48 C 19.133333 48 16.048194 47.030933 14.197266 46.105469 C 12.500509 45.25709 12.088248 44.658064 12 44.542969 L 12 13 C 12 9.4511148 14.618949 6.5430434 18.035156 6.0742188 z M 20 17 C 21.388889 17 22.288829 17.228651 23.695312 17.484375 C 25.101796 17.740099 26.944444 18 30 18 C 33.495974 18 35.304681 17.322825 35.912109 17.072266 L 38.662109 18.435547 A 1.0001 1.0001 0 0 0 38.755859 18.476562 C 39.832272 18.8801 40.69496 19.632974 41.263672 20.570312 C 40.580267 20.218229 39.817778 20 39 20 L 24 20 C 21.250484 20 19 22.250484 19 25 L 19 27 C 19 28.127936 19.392748 29.160943 20.029297 30 L 20 30 C 17.779625 30 16 28.220375 16 26 L 16 21 C 16 18.779625 17.779625 17 20 17 z M 24 22 L 25 22 C 26.544092 22 27.85983 22.86962 28.527344 24.140625 A 1.0001 1.0001 0 0 0 28.705078 24.492188 C 28.892912 24.957201 29 25.465114 29 26 C 29 26.534886 28.892912 27.042799 28.705078 27.507812 A 1.0001 1.0001 0 0 0 28.527344 27.859375 C 27.85983 29.13038 26.544092 30 25 30 L 24 30 C 22.331516 30 21 28.668484 21 27 L 21.5 27 C 21.776 27 22 26.776 22 26.5 L 22 25.5 C 22 25.224 21.776 25 21.5 25 L 21 25 C 21 23.331516 22.331516 22 24 22 z M 34 22 C 36.220375 22 38 23.779625 38 26 C 38 28.220375 36.220375 30 34 30 C 32.556481 30 31.317929 29.233131 30.615234 28.089844 C 30.859819 27.437465 31 26.735384 31 26 C 31 25.264616 30.859819 24.562535 30.615234 23.910156 C 31.317929 22.766869 32.556481 22 34 22 z M 38.455078 22 L 39 22 C 40.668484 22 42 23.331516 42 25 L 42 27 C 42 28.668484 40.668484 30 39 30 L 38.455078 30 C 39.411613 28.936212 40 27.535504 40 26 C 40 24.464496 39.411613 23.063788 38.455078 22 z M 32.5 25 C 32.224 25 32 25.224 32 25.5 L 32 26.5 C 32 26.776 32.224 27 32.5 27 L 33.5 27 C 33.776 27 34 26.776 34 26.5 L 34 25.5 C 34 25.224 33.776 25 33.5 25 L 32.5 25 z M 34 36.34375 L 34 43.039062 C 33.643823 43.139876 33.801941 43.14508 33.179688 43.269531 C 32.884639 43.328541 32.357733 43.375687 32 43.433594 L 32 36.628906 C 32.805599 36.545146 33.380115 36.443242 34 36.34375 z M 20 36.726562 C 21.215378 36.878507 22.500962 37 24 37 L 24 44 C 22.466691 44 21.193466 43.866804 20 43.705078 L 20 36.726562 z M 30 36.773438 L 30 43.710938 C 28.910113 43.822704 27.483831 43.87228 26 43.917969 L 26 36.923828 C 27.469471 36.893358 28.858489 36.852167 30 36.773438 z M 18 36.833984 L 18 43.179688 C 16.791137 42.485844 16 41.180231 16 39.707031 L 16 39.660156 C 16 38.327672 16.849736 37.236661 18 36.833984 z"></path>
                                </svg>}
                        </div>
                        <div className="employee-card-header">
                            {person ? person?.congratulateOnBirthday ? (
                                <div className="employee-active-status badge">Aktiv</div>
                            ) : (
                                <div className="employee-inactive-status badge">Inaktiv</div>
                            ) : null}

                            <div className=""></div>
                        </div>
                        <div className="employee-card-content">
                            <div className="employee-name border">{person?.name}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid-item2-container">
                <div className="content-name">{name}</div>
                <div className="section-header">Details</div>
                <div className="border section-content">
                    {/*<div className="flex-row-container border-bottom section-id">
                        <div className={"position-absolute"} onClick={() => setShowModal(true)}><Gear size={"1.4em"}/></div>
                        <div className={"flex-item1"}>ID</div>
                        <div className={"flex-item2"}>{id}</div>
                    </div>*/}
                    <div className="flex-row-container border-bottom">
                        <div className={"flex-item1"}>Name</div>
                        <div className={"flex-item2"}>{name}</div>
                    </div>
                    <div className="flex-row-container border-bottom">
                        <div className={"flex-item1"}>Telefonnummer</div>
                        <div className={"flex-item2"}>{formatTel(person?.tel)}</div>
                    </div>
                    <div className="flex-row-container">
                        <div className={"flex-item1"}>Geburtsdatum</div>
                        <div
                            className={"flex-item2"}>{person ? formatAndCalculateAge(person?.birthdate).formattedDate : ""}</div>
                    </div>
                </div>
                <div className="section-header">Einstellungen</div>
                <div className="border section-content">
                    <div className="fs-6 flex-row-container mb-1 pb-0">Geburtstage</div>
                    <div className="flex-row-container mt-0 border-bottom">
                        Hier findest alle Einstellungen zu {name}´s Geburtstag.
                    </div>
                    {person ? <div className="flex-row-container border-bottom">
                        <div className={"flex-item1 row"}>
                            <div className="col-12 fw-bold">Zum Geburtstag gratulieren</div>
                            <div
                                className="col-12">Aktuell wird {name} {person.congratulateOnBirthday ? '' :
                                <span className={"text-danger"}>nicht</span>} zum Geburtstag gratuliert
                            </div>

                        </div>
                        <div className={"flex-item2-toggle mt-2"}>
                            <Switch
                                checked={person.congratulateOnBirthday}
                                onChange={(newValue) => handleChange_congratulateOnBirthday(newValue)}
                                onColor="#86d3ff"
                                offColor="#e58e99"
                                offHandleColor="#dc3545"
                                onHandleColor="#2693e6"
                                handleDiameter={20}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                height={10}
                                width={33}
                                className="react-switch"
                            />
                        </div>
                    </div> : null}

                  {/*  {person && person.congratulateOnBirthday ? <div className="flex-row-container border-bottom">
                        <div className={"flex-item1 row"}>
                            <div className="col-12 fw-bold">Zum Geburtstag gratulieren</div>
                            <div
                                className="col-12">Aktuell wird {name} {person.congratulateOnBirthday ? '' :
                                <span className={"text-danger"}>nicht</span>} zum Geburtstag gratuliert
                            </div>

                        </div>
                        <div className={"flex-item2-toggle mt-2"}>
                            <Dropdown className={'_dropdown'} options={["Chat", "Gruppe"]} onChange={() => {
                            }} value={mapChatOrGroup(person.congratulateInChatOrGroup)}
                                      placeholder={mapChatOrGroup(person.congratulateInChatOrGroup)}/>
                        </div>
                    </div> : null}*/}
                </div>

                <div className="border section-content">
                    <div className="fs-6 flex-row-container mb-1 pb-0">Audio Transkribierung</div>
                    <div className="flex-row-container mt-0 border-bottom">
                        Hier werden Einstellungen rund um die Transkribierung von Audios vorgenommen, welche
                        dir {name} sendet.
                    </div>
                    {person ? <div className="flex-row-container border-bottom">
                        <div className={"flex-item1 row"}>
                            <div className="col-12 fw-bold">Transkribierung verstecken</div>
                            <div
                                className="col-12">{!person.transcribeHidden ? 'Aktuell wird die Audio im Chat transkribiert.' : `Aktuell wird die Audio in einem Chat mit dir selbst transkribiert, ohne dass ${name} das mitbekommt.`}</div>
                        </div>
                        <div className={"flex-item2-toggle mt-2"}>
                            <Switch
                                checked={person.transcribeHidden}
                                onChange={(newValue) => handleChange_transcribeHidden(newValue)}
                                onColor="#86d3ff"
                                offColor="#e58e99"
                                offHandleColor="#dc3545"
                                onHandleColor="#2693e6"
                                handleDiameter={20}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                height={10}
                                width={33}
                                className="react-switch"
                            />
                        </div>
                    </div> : null}

                    {person ? <div className="flex-row-container border-bottom">
                        <div className={"flex-item1 row"}>
                            <div className="col-12 fw-bold">Übersetzen <span className={"text-muted"}>[BETA]</span></div>
                            <div
                                className="col-12">Übersetzt die Audio ins deutsche
                            </div>
                        </div>
                        <div className={"flex-item2-toggle mt-2"}>
                            <Switch
                                checked={person.translateTranscriptions}
                                onChange={(newValue) => handleChange_translateTranscriptions(newValue)}
                                onColor="#86d3ff"
                                offColor="#e58e99"
                                offHandleColor="#dc3545"
                                onHandleColor="#2693e6"
                                handleDiameter={20}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                height={10}
                                width={33}
                                className="react-switch"
                            />
                        </div>
                    </div> : null}
                </div>
            </div>
        </div>

    </>)
}